import { gql } from '@apollo/client';

export const NOTIFICATIONS_SUBSCRIPTION = gql`
  subscription OnNotificationAdded {
    notifications {
      id
      createdAt
      institutionId
      registrationId
      message
      startDate
      title
      topic
      notificationType
      read
    }
  }
`;
